import { useStaticQuery, graphql } from 'gatsby';
import { Menu } from './types';

const usePrimaryNav = (): Menu => {
    const { csPrimaryNav } = useStaticQuery(
        graphql`
      query PrimaryNav {
        csPrimaryNav {
          navItems {
            navItemLink {
              href
              title
            }
            columns {
              group {
                categoryLink {
                  href
                  title
                }
                icon {
                  title
                  url
                }
                iconInverse {
                  title
                  url
                }
                subgroup {
                  title
                  subgroupLink {
                    href
                    title
                  }
                  links {
                    href
                    title
                  }
                }
              }
            }
          }
        }
      }
    `,
    );
    return csPrimaryNav;
};

export default usePrimaryNav;
